/* eslint-disable react/jsx-no-target-blank */
import { Button, Drawer } from "antd";
import React, { useContext, useState } from "react";
import {
  UnorderedListOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { objectiveContext } from "../../../context/Objective";

function Header() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [solutionStatus, setSolutionStatus] = useState(false);
  const [companyStatus, setCompanyStatus] = useState(false);
  const { companyActive, solutionActive, setSolutionActive, setCompanyActive } =
    useContext(objectiveContext);

  // icons style
  const iconsStyle =
    "mr-[10px] rounded-full bg-[#161616] flex items-center justify-center w-[35px] h-[32px] cursor-pointer";

  // menu styles
  const menuStyles =
    "text-[white] pr-[40px] font-medium text-[20px] cursor-pointer";

  return (
    <div className="bg-[#2D2D2D] h-[60px] flex items-center justify-between w-full py-[20px] px-[50px] max-sm:px-[25px] navBar relative max-[380px]:px-[15px] z-[10000]">
      <div className="logo">
        <div className="cursor-pointer w-[300px] max-sm:w-[200px] max-[500px]:w-[150px] mt-1">
          <Link className="flex flex-col items-center" to="/">
            <img
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
              }}
              src="/assets/meta.png"
              alt="logo"
            />
          </Link>
        </div>
      </div>
      <div className="items-center hidden min-[1100px]:flex">
        <div className=" pr-[30px] text-[white] font-bold cursor-pointer">
          <div
            onClick={() => {
              setCompanyActive(false);
              setSolutionActive(!solutionActive);
            }}
          >
            SOLUTIONS
          </div>
        </div>
        <div className=" pr-[30px] text-[white] font-bold cursor-pointer">
          <div
            onClick={() => {
              setCompanyActive(!companyActive);
              setSolutionActive(false);
            }}
          >
            COMPANY
          </div>
        </div>
        <Link to="/contact">
          <div
            onClick={() => {
              setCompanyActive(false);
              setSolutionActive(false);
              window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
            }}
            className="text-[white] pr-[40px] font-bold text-[14px] uppercase"
          >
            Contact
          </div>
        </Link>
        <div className="pr-[40px] font-bold">
          <a
            href="https://calendly.com/razametaworldx/30min"
            className="!font-bold"
            target="_blank"
          >
            <Button type="primary" className="!font-bold">
              BOOK A DEMO
            </Button>
          </a>
        </div>
        <div className="flex items-center justify-center">
          <a href="https://www.facebook.com/metaworld.x" target="_blank">
            <div className={iconsStyle}>
              <img src="/assets/Facebook.svg" alt="facebook" />
            </div>
          </a>
          <a
            href="https://www.instagram.com/metaworld.x/?igshid=YmMyMTA2M2Y%3D"
            target="_blank"
          >
            <div className={iconsStyle}>
              <img src="/assets/Instagram.svg" alt="instagram" />
            </div>
          </a>
          <a href="https://twitter.com/MetaWorldX" target="_blank">
            <div className={iconsStyle}>
              <img src="/assets/Twitter.svg" alt="twitter" />
            </div>
          </a>
          <a
            href="https://www.linkedin.com/company/metaworldx/"
            target="_blank"
          >
            <div className={iconsStyle}>
              <img src="/assets/LinkedIn.svg" alt="linkedIn" />
            </div>
          </a>
        </div>
      </div>
      <div className="hidden max-[1099px]:flex items-center justify-center">
        <div className=" pr-[30px] max-[500px]:pr-[20px] font-bold">
          <a
            href="https://calendly.com/razametaworldx/30min"
            className="!font-bold"
            target="_blank"
          >
            <Button
              type="primary"
              className="!font-bold max-[500px]:!text-[10px]"
            >
              BOOK A DEMO
            </Button>
          </a>
        </div>
        <div>
          <UnorderedListOutlined
            onClick={() => setOpenDrawer(true)}
            className="!text-[30px] !text-[white]"
          />
        </div>
      </div>

      <Drawer
        className="navBar_drawer"
        open={openDrawer}
        placement="right"
        closeIcon={
          <CloseCircleOutlined
            className="!text-[30px] !text-[white]"
            onClick={() => setOpenDrawer(false)}
          />
        }
        width="100%"
        bodyStyle={{
          backgroundColor: "#2D2D2D",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        headerStyle={{ backgroundColor: "#2D2D2D", border: "none" }}
      >
        <div className="flex w-full justify-center items-center flex-col text-center mt-[-20px]">
          <ul>
            <li className={`${menuStyles} relative`}>
              <div onClick={() => setSolutionStatus(!solutionStatus)}>
                Solutions
              </div>
              {solutionStatus ? (
                <div className="flex justify-center items-center absolute right-[-20px] top-[10px]">
                  <MinusOutlined
                    className="!text-[15px]"
                    onClick={() => setSolutionStatus(false)}
                  />
                </div>
              ) : (
                <div className="flex justify-center items-center absolute right-[-20px] top-[10px]">
                  <PlusOutlined
                    className="!text-[15px]"
                    onClick={() => setSolutionStatus(true)}
                  />
                </div>
              )}
            </li>
            {solutionStatus && (
              <>
                <Link to="/solutions/critical-infrastructure">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    Critical Infrastructure
                  </li>
                </Link>
                <Link to="/solutions/cyber-security">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    Cyber Security
                  </li>
                </Link>
                <Link to="/solutions/health-care">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    Health Care
                  </li>
                </Link>
                <Link to="/solutions/real-estate">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    Real Estate
                  </li>
                </Link>
                <Link to="/solutions/smart-cities">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    Smart Cities
                  </li>
                </Link>
              </>
            )}
            <li className={`${menuStyles} relative`}>
              <div onClick={() => setCompanyStatus(!companyStatus)}>
                Company
              </div>
              {companyStatus ? (
                <div className="flex justify-center items-center absolute right-[-20px] top-[10px]">
                  <MinusOutlined
                    className="!text-[15px]"
                    onClick={() => setCompanyStatus(false)}
                  />
                </div>
              ) : (
                <div className="flex justify-center items-center absolute right-[-20px] top-[10px]">
                  <PlusOutlined
                    className="!text-[15px]"
                    onClick={() => setCompanyStatus(true)}
                  />
                </div>
              )}
            </li>
            {companyStatus && (
              <>
                <Link to="/our-story">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    Our Story
                  </li>
                </Link>
                <Link to="/news">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    News
                  </li>
                </Link>
                <Link to="/careers">
                  <li
                    onClick={() => {
                      window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                      setOpenDrawer(false);
                    }}
                    className={`${menuStyles} font-normal text-[#ffffffa8]`}
                  >
                    Jobs and Careers
                  </li>
                </Link>
              </>
            )}
            <Link to="/contact">
              <li
                onClick={() => {
                  window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
                  setOpenDrawer(false);
                }}
                className={menuStyles}
              >
                Contact
              </li>
            </Link>
          </ul>
          <div className="flex items-center justify-center mt-3">
            <a href="https://www.facebook.com/metaworld.x" target="_blank">
              <div className={iconsStyle}>
                <img src="/assets/Facebook.svg" alt="facebook" />
              </div>
            </a>
            <a
              href="https://www.instagram.com/metaworld.x/?igshid=YmMyMTA2M2Y%3D"
              target="_blank"
            >
              <div className={iconsStyle}>
                <img src="/assets/Instagram.svg" alt="instagram" />
              </div>
            </a>
            <a href="https://twitter.com/MetaWorldX" target="_blank">
              <div className={iconsStyle}>
                <img src="/assets/Twitter.svg" alt="twitter" />
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/metaworldx/"
              target="_blank"
            >
              <div className={iconsStyle}>
                <img src="/assets/LinkedIn.svg" alt="linkedIn" />
              </div>
            </a>
          </div>
        </div>
      </Drawer>

      {solutionActive && (
        <div className="h-[35px] absolute bottom-[-35px] left-0  w-full bg-[#2f2f2f80] flex items-center justify-end text-[white] text-[13px]">
          <Link to="/solutions/critical-infrastructure">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              CRITICAL INFRASTRUCTURE
            </div>
          </Link>
          <Link to="/solutions/cyber-security">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              CYBER SECURITY
            </div>
          </Link>
          <Link to="/solutions/health-care">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              HEALTH CARE
            </div>
          </Link>
          <Link to="/solutions/real-estate">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              REAL ESTATE
            </div>
          </Link>
          <Link to="/solutions/smart-cities">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              SMART CITIES
            </div>
          </Link>
        </div>
      )}
      {companyActive && (
        <div className="h-[35px] absolute bottom-[-35px] left-0  w-full bg-[#2f2f2f80] flex items-center justify-end text-[white] text-[13px]">
          <Link to="/our-story">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              OUR STORY
            </div>
          </Link>
          <Link to="/news">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              NEWS
            </div>
          </Link>
          <Link to="/careers">
            <div
              onClick={() => {
                setCompanyActive(false);
                setSolutionActive(false);
                window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
              }}
              className="pr-[30px] cursor-pointer text-[white]"
            >
              JOBS AND CAREERS
            </div>
          </Link>
        </div>
      )}
    </div>
  );
}

export default Header;
